import { render, staticRenderFns } from "./NewList.vue?vue&type=template&id=af21d270&scoped=true"
import script from "./NewList.vue?vue&type=script&lang=js"
export * from "./NewList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af21d270",
  null
  
)

export default component.exports